import { Paged } from 'domains/appDomain';
import {
  JobProjectAddJobParams,
  Project,
  ProjectCopyParams,
  ProjectDeleteParams,
  ProjectJobDetail,
  ProjectJobSummary,
  ProjectListParams,
} from 'domains/projectDomain';
import api from 'utils/api';
import { JobItem } from '../domains/workspaceDomain';

const projectService = {
  createProject: async () => {
    return api.post<ProjectJobSummary>(`/job-projects`);
  },

  getProjectPage: async ({
    active,
    page,
    size,
    sort,
    isDesc,
  }: Partial<ProjectListParams>) => {
    return api.get<Paged<Project>>(
      `/job-projects/page?page=${Number(page) - 1 || 0}&size=${
        size || 12
      }&sort=${sort || 'projectName'}${isDesc ? ',desc' : ''}`,
      {
        active,
      }
    );
  },

  updateProject: async (id: string, payload: Partial<Project>) => {
    return api.put<Project>(`/job-projects/${id}`, payload);
  },

  deleteProject: async (payload: ProjectDeleteParams) => {
    return api.delete(`/job-projects/${payload.id}`, payload);
  },

  copyProject: async (payload: ProjectCopyParams) => {
    return api.post<Project>(`/job-projects/${payload.id}/copy`, payload);
  },

  getProjectDetail: async (id: string) => {
    return api.get<Project>(`/job-projects/${id}`);
  },

  jobProjectAddJob: async (payload: JobProjectAddJobParams) => {
    return api.post<ProjectJobDetail>(
      `/job-projects/${payload.projectId}/jobs`,
      payload
    );
  },
  saveProjectJobsSort: async (jobProjectId: string, payload: string[]) => {
    return api.post(`/job-projects/${jobProjectId}/jobs/resequence`, payload);
  },
  getJobDetailByQuoteId: async (quoteId: string) => {
    return api.get<JobItem>(
      `/job-workspace/get-by-quote-id?quoteId=${quoteId}`
    );
  },
  getJobDetailByJobId: async (jobId: number) => {
    return api.get<JobItem>(`/job-workspace?jobId=${jobId}`);
  },
  delJobDetailByJoinId: async (
    jobProjectId: string,
    projectJobJoinId: number,
    deleteJobConfig: boolean
  ) => {
    return api.delete(
      `/job-projects/${jobProjectId}/jobs/${projectJobJoinId}?deleteJobConfig=${deleteJobConfig}`
    );
  },
};

export default projectService;
